/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'

import PopUp from '../../../../common/PopUp/PopUp'
import { Redirect } from 'react-router-dom'
import DatePicker from '../../../../common/DatePicker/DatePicker'
import { currency, symbol } from '../../../../common/CurrencyFormat'

export default class BindContainer extends React.Component<any, any> {

    constructor(props: any) {
        super(props)
        this.state = {
            softRef: this.props.softReferrals,
            softRefMessage: '',
            bindInceptionDate: null,
            showInceptionPopUp: false,
            boundPopupQuoteId: null,
            boundPopup: false,
            boundBind: false,
            reqRate: false,
        }
    }

    componentDidMount() {
        this.props.checkSoftReferral(this.props.quoteId, this.props.varId)
    }

    componentDidUpdate(nextProps: any, nextState: any) {
        if (nextProps.softReferrals !== this.state.softRef) {
            this.setState({ softRef: nextProps.softReferrals })
        }
    }

    /**
     * Function to manage Bind Action
     */
    handleBind = () => {
        this.props.bindQuoteVariation(this.props.quoteId, this.props.values.id, this.state.bindInceptionDate).
            then((response) => {
                if (response.value) {
                    this.setState({
                        boundBind: true,
                        boundPopupQuoteId: response.value.policy.id,
                    })
                }
            }).catch((response) => {
                if (response.error) {
                    this.props.handleClosePopup()
                }
            })
    }

    handlePostReasons = () => {
        this.props.postSoftReferral(this.props.quoteId, this.props.values.id, { reason: this.state.softRefMessage })
        this.setState({ softRefMessage: '' })
        this.props.removeSoftReferral()
        this.props.handleClosePopup()
        this.props.postIssuedQuotePopUp()
    }

    printDate = () => {
        // console.log("print date", this.props)

        // let today = new Date()
        // let dd = today.getDate()
        // let mm = today.getMonth() + 1
        // let ddString = ''
        // let mmString = ''
        // let yyyy = today.getFullYear()

        // if (dd < 10) {
        //     ddString = '0' + dd.toString()
        // } else {
        //     ddString = dd.toString()
        // }

        // if (mm < 10) {
        //     mmString = '0' + mm.toString()
        // } else {
        //     mmString = mm.toString()
        // }

        // return `${ddString}-${mmString}-${yyyy}`
        return this.props.step05.creationDate
    }

    handleEndRoute = () => {
        this.setState({
            boundPopup: true,
        })
    }

    render() {
        /**
         * If server returns a success response from post_referral_reasons
         * it redirects to Dashboard
         */
        if (this.props.postSoftRef && this.props.postSoftRef !== null) {
            return (
                <Redirect to="/dashboard" />
            )
        }

        if (this.state.boundPopup) {
            return (<Redirect to={`/quote/${this.state.boundPopupQuoteId}/summary`} />)
            // return (<Redirect to={`/clients/quotes/bound/${this.state.boundPopupQuoteId}`} />)
        }

        /**
         * Loading
         */
        if (this.state.softRef.loading) {
            return (
                <LoadingComp handleClosePopup={this.props.handleClosePopup} />
            )
        }

        if (this.state.boundBind) {
            return (
                <PopUp
                    title="Quote Bound"
                    buttonText={`Quote Bound`}
                    action={() => this.handleEndRoute()}
                >
                    The quote has been bound
                </ PopUp>
            )
        }

        if (!this.state.softRef.loading && this.state.softRef.response.length === 0 && !this.state.bindInceptionDate) {
            return (
                < PopUp
                    title="Select Inception Date"
                    buttonText="Cancel"
                    action={() => {
                        this.props.handleClosePopup()
                        this.setState({ bindInceptionDate: null })
                    }}
                >
                    <div className="quotePreview__box">
                        <div className="quotePreview__row">
                            <div className="text">
                                Please enter the inception date:
                            </div>
                            <div className="quotePreview__row__inception_date">
                                <DatePicker
                                    placeholder="Policy inception date"
                                    step05inceptionDate={this.printDate()}
                                    onChange={(bindInceptionDate) => this.setState({ bindInceptionDate })}
                                    onFocus={() => null}
                                />
                            </div>
                        </div>
                    </div>
                </PopUp >
            )
        }

        /**
         * Summary to confirm bind
         */
        if (!this.state.softRef.loading && this.state.softRef.response.length === 0 && this.state.bindInceptionDate) {
            return (
                <ConfirmComp
                    values={this.props.values}
                    handleClosePopup={() => {
                        this.props.handleClosePopup()
                        this.setState({ bindInceptionDate: null })
                    }}
                    printDate={this.printDate()}
                    handleBind={this.handleBind}
                    commission={this.props.commission}
                    inceptionDate={this.state.bindInceptionDate}
                    excess={this.props.excess}
                    isCollectors={this.props.isCollectors}
                />
            )
        }

        /**
         * List of soft referrals
         */
        if (!this.state.softRef.loading && this.state.softRef.response.length !== 0) {
            return (
                <ListComp
                    handleClosePopup={this.handlePostReasons}
                    changeText={(softRefMessage) => this.setState({ softRefMessage })}
                    referrals={this.state.softRef.response}
                />
            )
        }

        return (
            <div />
        )

    }
}

const ListComp = (props: any) => (
    <PopUp
        title="Referral"
        buttonText="Accept"
        action={props.handleClosePopup}
        numberButtons={1}
    >
        <div className="quotePreview__box softRef">
            Due to the below you will need to provide more information.

            <div className="softRef__list">
                {props.referrals.map((ref, i) => (
                    <div key={i} className="softRef__item">
                        <span>{ref.title}:</span>
                        {ref.description}
                    </div>
                ))}
            </div>

            <textarea
                placeholder="Explain in a few words your reasons"
                onChange={(event) => { props.changeText(event.target.value) }}
            />
        </div>
    </PopUp>
)

const ConfirmComp = (props: any) => (

    < PopUp
        title="Do you want to bind this quote?"
        buttonText="Bind"
        action={props.handleBind}
        numberButtons={2}
        secondaryButtonText="Cancel"
        secondaryAction={props.handleClosePopup}
    >
        <div className="quotePreview__box">
            <div className="quotePreview__header">
                <div className="quotePreview__header__title">
                    {props.values.businessName}
                </div>
                <div className="quotePreview__header__subtitle">
                    {(props.isCollectors) ? 'Collections Insurance' : 'Commercial Art Insurance'}
                </div>
                <div className="quotePreview__header__policyInfo">
                    Policy no. <span>{props.values.quoteRef}</span>
                </div>
            </div>

            <div className="quotePreview__row">
                <div className="quotePreview__infoBlock">
                    <div className="quotePreview__infoBlock__title">Inception date</div>
                    <div className="quotePreview__infoBlock__value">
                        <span>{props.inceptionDate}</span>
                    </div>
                </div>
                <div className="quotePreview__infoBlock">
                    <div className="quotePreview__infoBlock__title">Date quoted</div>
                    <div className="quotePreview__infoBlock__value">
                        <span>{props.printDate}</span>
                    </div>
                </div>
            </div>

            <div className="quotePreview__row">
                <div className="quotePreview__infoBlock">
                    <div className="quotePreview__infoBlock__title">Premium</div>
                    <div className="quotePreview__infoBlock__value">
                        <span>{currency(props.values.premium)}</span> inc.IPT
                    </div>
                </div>
                <div className="quotePreview__infoBlock">
                    <div className="quotePreview__infoBlock__title">Your commission</div>
                    <div className="quotePreview__infoBlock__value">
                        <span>{props.commission}%</span>
                    </div>
                </div>
                <div className="quotePreview__infoBlock">
                    <div className="quotePreview__infoBlock__title">Excess</div>
                    <div className="quotePreview__infoBlock__value">
                        <span>{symbol()} {props.excess}</span>
                    </div>
                </div>
            </div>

        </div>
    </PopUp >
)

const LoadingComp = (props: any) => (
    <PopUp
        title="Loading"
        buttonText="Loading"
        action={props.handleClosePopup}
        numberButtons={1}
    >
        <div className="quotePreview__box">
            Loading
        </div>
    </PopUp>
)



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/pages/Quote/Step05/components/BindContainer.tsx